<div
  class="gd-form-textarea-v2">

  <!-- Input data -->
  <mat-form-field
    *ngIf="!viewOnly; else viewOnlyTemplate"
    appearance="outline">

    <!-- Place holder -->
    <mat-label>
      {{ placeholder | translate }}
    </mat-label>

    <!-- Textarea -->
    <textarea
      matInput
      [(ngModel)]="value"
      (blur)="onTouchItem()"
      [errorStateMatcher]="errMatcher"
      [disabled]="disabled"
      [required]="required"></textarea>

    <!-- Right - Icon buttons -->
    <ng-container
      *ngFor="let iconB of suffixIconButtons"
      matSuffix>
      <span
        *ngIf="!iconB.visible || iconB.visible(this)"
        (click)="$event.stopPropagation()">
        <button
          tabindex="-1"
          type="button"
          mat-icon-button
          [matTooltip]="iconB.tooltip | translate"
          [disabled]="iconB.disabled && iconB.disabled(this)"
          (click)="iconB.clickAction ? iconB.clickAction(this) : undefined"><mat-icon>{{iconB.icon}}</mat-icon></button>
      </span>
    </ng-container>

    <!-- Errors -->
    <mat-error
      *ngIf="control?.invalid && control?.touched">
      {{ getErrorMessages() }}
    </mat-error>

  </mat-form-field>

  <!-- View only -->
  <ng-template
    #viewOnlyTemplate>
    <div
      fxLayout="row" fxLayoutGap="1.6rem"
      class="gd-form-textarea-v2-viewonly">
      <!-- Label -->
      <div
        class="gd-form-textarea-v2-viewonly-label">
        {{ placeholder | translate }}:
      </div>

      <!-- Value -->
      <div
        class="gd-form-textarea-v2-viewonly-value">
        {{value ? value : noValueLabel}}
      </div>
    </div>
  </ng-template>
</div>
